import authAPI from "@/api/auth";
import { setItem } from "@/helpers/persistanceStorage";
import { removeItem } from "@/helpers/persistanceStorage";
import axios from "@/api/axios";

const state = {
  showLoader: false,
  isLoginFormSubmitting: false,
  currentUser: null,
  loginErrors: null,
  isLoggedIn: false,
};

const mutations = {
  getUserSuccess(state, payload) {
    state.currentUser = payload;
  },
  getUserFailure(state) {
    state.currentUser = null;
  },
  loginStart(state) {
    state.isLoginFormSubmitting = true;
    state.loginErrors = null;
    state.showLoader = true;
  },
  loginSuccess(state) {
    state.isLoginFormSubmitting = false;
    state.isLoggedIn = true;
    state.showLoader = false;
  },
  loginFailure(state, payload) {
    state.isLoginFormSubmitting = false;
    state.isLoggedIn = false;
    state.loginErrors = payload;
    state.showLoader = false;
  },
};

const getters = {
  loginErrors(state) {
    return state.loginErrors;
  },
  isLoginFormSubmitting(state) {
    return state.isLoginFormSubmitting;
  },
  showLoader(state) {
    return state.showLoader;
  },
  currentUser(state) {
    return state.currentUser;
  },
};

const actions = {
  login(context, credentials) {
    context.commit("loginStart");
    return new Promise((resolve) => {
      authAPI
        .login(credentials)
        .then((response) => {
          setItem("accessToken", response.data.token);
          axios.defaults.headers.common["Authorization"] =
            process.env.VUE_APP_AUTHPREFIX + " " + response.data.token;
          context.commit("loginSuccess", response.data);
          resolve(response.data);
        })
        .catch((result) => {
          removeItem("accessToken");
          delete axios.defaults.headers.common["Authorization"];
          context.commit("loginFailure", result.response.data);
        });
    });
  },

  get_user_info(context) {
    return new Promise((resolve) => {
      authAPI
        .get_user_info()
        .then((response) => {
          context.commit("getUserSuccess", response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit("getUserFailure", result);
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
